module.exports = __webpack_public_path__ + "static/media/Group9224.36b549d4.svg";